
import Header from './Header';
import Footer from './Footer';
import Navbar from './Navbar';
import NavbarHorizontal from './NavbarHorizontal';
import Sidebar from './Sidebar';
import Wrapper from './Wrapper';
import Inbox from './Inbox';
import Loading from './Loading';
import Search from './Search';
import Tasks from './Tasks';
import DataTable from './DataTable';
import ModalAbout from './ModalAbout';
import ModalLogout from './ModalLogout';
import ModalProfile from './ModalProfile';
import LineChart from './Charts/LineChart';
import DonutChart from './Charts/DonutChart';
import BarChart from './Charts/BarChart';
import MiniLineChart from './Charts/MiniLineChart';
import CardDevices from './CardDevices';
import CardActivity from './CardActivity';
import CardList from './CardList';
import ProfileAccordion from './ProfileAccordion';
import ProfileSlider from './ProfileSlider';
import ContentSlider from './ContentSlider';
import IconsSimpleLine from './IconsSimpleLine';
import IconsLinear from './IconsLinear';

export {
    Header,
    Footer,
    Navbar,
    NavbarHorizontal,
    Sidebar,
    Wrapper,
    Inbox,
    Search,
    Tasks,
    Loading,
    DataTable,
    ModalAbout,
    ModalLogout,
    ModalProfile,
    LineChart,
    DonutChart,
    BarChart,
    MiniLineChart,
    CardDevices,
    CardActivity,
    CardList,
    ProfileAccordion,
    ProfileSlider,
    ContentSlider,
    IconsSimpleLine,
    IconsLinear
};